/**
 * Stationen-Leiste „Anfrage ✓ · Angebot ✓ · AB ✓ · Anzahlung · Termin · Rechnung · Bezahlt“ (06.10.2026),
 * gemeinsam für „Dokumente & Vorgänge“ (je AB) und die Vorgangskette im Projekt (A-015b).
 * Nur Anzeige, aus vorhandenen Daten berechnet. order darf fehlen (Projekt ohne AB).
 */
export const anzahlungsRechnungen = (invoices, orderId) =>
  invoices.filter((i) => i.art === "anzahlung" && i.order_id === orderId && i.status !== "Storniert");

export const anzahlungStand = (order, invoices) => {
  const vereinbart = Number(order?.deposit_amount || 0);
  const bezahlt = order ? Math.round(anzahlungsRechnungen(invoices, order.id).reduce((s, i) => s + Number(i.total_gross || 0), 0) * 100) / 100 : 0;
  return { vereinbart, bezahlt, offen: Math.max(0, Math.round((vereinbart - bezahlt) * 100) / 100) };
};

export const stationenBerechnen = ({ kunde, termine = [], quotes = [], invoices = [], order = null }) => {
  const anz = anzahlungStand(order, invoices);
  const angebot = order
    ? quotes.find((q) => q.id === order.quote_id) || quotes.find((q) => q.status === "Beauftragt")
    : quotes.find((q) => q.status && q.status !== "Entwurf");
  const rechnungen = invoices.filter((i) => (!order || i.order_id === order.id) && i.art !== "anzahlung" && i.status !== "Storniert");
  const terminFest = termine.some((t) => t.status && !["wartet_auf_go", "abgesagt"].includes(t.status));
  return [
    { key: "anfrage", label: "Anfrage", ok: !!(kunde?.anliegen || kunde?.nachricht) || quotes.length > 0 },
    { key: "angebot", label: "Angebot", ok: !!angebot },
    // AB erledigt: versendet ODER Anzahlung dazu gebucht ODER Anzahlungsrechnung vorhanden (06.10.2026)
    { key: "ab", label: "AB", ok: !!order && (!!order.versendet_am || !["Offen", "", undefined].includes(order.status)
        || (order.zahlungsvermerke || []).some((v) => v.art === "anzahlung_gebucht")
        || invoices.some((i) => i.art === "anzahlung" && i.order_id === order.id)) },
    anz.vereinbart > 0
      ? { key: "anzahlung", label: "Anzahlung", ok: anz.offen <= 0.005 }
      : { key: "anzahlung", label: "Anzahlung", ok: true, text: "keine" },
    { key: "termin", label: "Termin", ok: terminFest },
    { key: "rechnung", label: "Rechnung", ok: rechnungen.some((i) => i.status && i.status !== "Entwurf") },
    { key: "bezahlt", label: "Bezahlt", ok: rechnungen.some((i) => i.status === "Bezahlt") },
  ];
};

export const StationenLeiste = ({ stationen, testId, idSuffix, className = "" }) => (
  <div className={`flex flex-wrap items-center gap-1 text-[11px] ${className}`} data-testid={testId}>
    {stationen.map((st, idx) => (
      <span key={st.key} className="flex items-center gap-1">
        {idx > 0 && <span className="text-slate-300">·</span>}
        <span data-testid={`station-${st.key}-${idSuffix}`} data-ok={st.ok ? "1" : "0"}
          className={`px-1.5 py-0.5 rounded-sm ${st.ok ? "bg-green-50 text-green-800" : "bg-slate-100 text-slate-500"}`}>
          {st.label} {st.text || (st.ok ? "✓" : "offen")}
        </span>
      </span>
    ))}
  </div>
);
